import { render, staticRenderFns } from "./PointDistributionQuestion.vue?vue&type=template&id=2add4424"
import script from "./PointDistributionQuestion.vue?vue&type=script&lang=js"
export * from "./PointDistributionQuestion.vue?vue&type=script&lang=js"
import style0 from "./PointDistributionQuestion.vue?vue&type=style&index=0&id=2add4424&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports